<!-- modal ver esc-->
<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="1100" persistent scrollable>
      <v-card class="ve-card">
        <v-card-title class="ve-hero py-3">
          <div class="d-flex align-center justify-space-between" style="width: 100%;">
            <div class="d-flex align-center" style="gap: 12px;">
              <v-avatar color="white" size="40" class="elevation-1">
                <v-icon color="teal darken-3">mdi-clipboard-check-outline</v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 white--text">Programas Universidad escogidos</div>
                <div class="text-body-2 white--text">
                  Asigna la sede y confirma los programas aprobados
                </div>
              </div>
            </div>
            <v-chip color="teal lighten-5" class="teal--text text--darken-3" small>
              Registros: {{ filteredEscogidos?filteredEscogidos[0]?filteredEscogidos[0].seleccionados.length : 0 :0  }}
            </v-chip>
          </div>
        </v-card-title>

        <v-card-text class="pt-2">
          <v-divider class="mb-4" />
          <v-row dense class="mb-2">
            <v-col cols="12" sm="6" md="4">
              <v-select
                :items="xmeses"
                v-model="input.mes"
                label="Mes de oferta"
                item-value="id"
                item-text="text"
                dense
                outlined
                prepend-icon="mdi-calendar"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Año de oferta"
                v-model.number="input.anio"
                dense
                outlined
                prepend-icon="mdi-calendar"
                type="number"
              />
            </v-col>
          </v-row>

          <v-fade-transition v-if="loading">
            <div>
              <v-progress-linear indeterminate color="primary" class="mb-4" />
              <v-skeleton-loader type="table" class="mb-4" />
              <v-skeleton-loader type="table" />
            </div>
          </v-fade-transition>

          <v-fade-transition v-else>
            <div>
              <v-row v-if="filteredEscogidos.length === 0">
                <v-col cols="12">
                  <v-alert type="info" border="left" colored-border>
                    No hay registros para el mes seleccionado.
                  </v-alert>
                </v-col>
              </v-row>

              <v-row v-for="(e,ind) in filteredEscogidos" :key="ind" dense>
                <v-col cols="12">
                  <v-card outlined class="pa-3">
                    <div class="text-subtitle-2">
                      Oferta: {{ e.nombre_oferta }}
                    </div>
                    <div class="text-body-2 text--secondary">
                      Periodo: {{ mesTexto(e.mes) }} · {{ e.anio }}
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="xheaders_punis"
                    :items="e.seleccionados"
                    disable-pagination
                    hide-default-footer
                    dense
                    class="elevation-1"
                    no-data-text="No hay programas en esta oferta"
                  >
                    <template v-slot:[`item.sede`]="{ item }">
                      <v-autocomplete
                        v-model="item.sede"
                        :items="xsedes"
                        item-value="id"
                        item-text="nombre"
                        :return-object="true"
                        dense
                        outlined
                        clearable
                        hide-details
                        placeholder="Seleccione la sede..."
                        style="min-width: 220px; max-width: 260px;"
                        class="my-1"
                      />
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn color="teal darken-2" class="white--text" :loading="loading_aprob" @click="aprobar_seleccion(e)">
                    <v-icon left small>mdi-check-circle</v-icon>
                    Confirmar y Aprobar
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-fade-transition>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="green" :loading="loading" outlined @click="enviar()"> Guardar seleccion </v-btn> -->
          <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script> 
import {headers_punis2, meses} from './utils';
import gql from 'graphql-tag'

  export default {
    data() {
      return {
        loading: true, 
        loading_aprob: false, 
        dialog: false,    
        xheaders_punis: [],
        xmeses: [],
        xsedes: [],
        escogidos: [],
        filteredEscogidos: [],
        input:{
            nombre_oferta:'',
            mes: new Date().getMonth(),
            anio: new Date().getFullYear(),
        }
      };
    }, 
    watch:{
      'input.mes': function() {
        this.listar()
      },
      'input.anio': function() {
        this.listar()
      }
    },
    methods: {
      async openmodal() {  
        this.dialog = true; 
        this.input.nombre_oferta = '';
        this.input.mes = new Date().getMonth();
        this.input.anio = new Date().getFullYear(); 
        this.xheaders_punis = headers_punis2();
        this.xmeses = meses();
        this.escogidos = []

        this.loading = true;
        await this.getSedes()
        this.listar()
      }, 
      mesTexto(mesId) {
        const m = this.xmeses.find(x => x.id === mesId);
        return m ? m.text : mesId;
      },
      cerrar() {
        this.dialog = false;
      }, 
      async getSedes() {
        const qs = gql` query {getSedes ${''} {id,nombre,unidad_negocio}}`;
        const res = await this.$apollo.query({ query: qs }).then(({ data }) => data).catch(e => e);
        if(res && res.getSedes){
          this.xsedes = res.getSedes;
        }
      },
      async listar() {
        this.loading = true;
        const q = {
          mes: this.input.mes,
          anio: this.input.anio,
        }
        
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const graphql = JSON.stringify({
          query: "query escogidos($q:QueryEscogidos!){ escogidos(q:$q){id seleccionados_por nombre_oferta mes anio seleccionados aprobados fecha_registro} }",
          variables: {q:q}
        })
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: graphql, 
        };

        const res = await fetch(process.env.VUE_APP_PROYECTOS_API, requestOptions).then(r=>r.json()).then(({data})=>data).catch(e=>e)
        
        // window.console.log('res',res);
        if(res && res.escogidos){
            res.escogidos.map(e=>{
                e.seleccionados = JSON.parse(e.seleccionados);
                e.aprobados = JSON.parse(e.aprobados); 
                if(!e.aprobados) e.aprobados = []
                e.aprobados.forEach(a=>{ 
                  const sel = e.seleccionados.find(s=>s.programaNombre==a.programaNombre);
                  if(sel) sel.sede = a.sede;
                })
                return e;
            })
            this.escogidos = res.escogidos;
            this.filteredEscogidos = res.escogidos;
        }
        this.loading = false;
      },

      async aprobar_seleccion(row){
        window.console.log('aprobar',row);

        const xaprobar = []; 
        row.seleccionados.forEach(s=>{ 
          if(s.sede){
            xaprobar.push(s)
          }
        })  

        let msg = '';
        if(msg) {
          this.$root.$notify.show(msg, { color: 'red', x: 'right' });
          return;
        }
        this.loading_aprob = true;
        const datos = {
          id_escogidos: row.id,
          aprobados: JSON.stringify(xaprobar),
        }

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const graphql = JSON.stringify({
          query: "mutation save_aprobados($input:NewAprobados!){ save_aprobados(input:$input){id aprobados fecha_registro} }",
          variables: { "input":datos }
        })
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: graphql, 
        };

        const res = await fetch(process.env.VUE_APP_PROYECTOS_API, requestOptions).then(r=>r.json()).then(({data})=>data).catch(e=>e)
        this.loading_aprob = false;
        window.console.log('res',res);
        if(res && res.save_aprobados){
          this.$root.$notify.show('Seleccion guardada', {
            color: 'green',
            x: 'right',
          }); 
          this.cerrar()
        }
      }
    },
  };
</script>

<style scoped>
.ve-card {
  border-radius: 14px;
  overflow: hidden;
}
.ve-hero {
  background: linear-gradient(120deg, #004D40 0%, #00796B 45%, #4DB6AC 100%);
}
</style>
